<template>
    <div>
        <div class="d-flex flex-column gap-2 ans-q-container" v-for="(question,idx) in this.template.questions"
             :key="idx">
            <div class="d-flex justify-content-between align-items-center">
                <div class="d-block w-75">
                    <div class="mb-2">Question {{idx+1}}</div>
<!--                    <div class="q-content">{{question['question']}}</div>-->
                    <textarea id="" type="text" placeholder="Enter Answer" class="q-input w-100"
                              autocomplete="off"
                              :value="question['question']"
                    >
                    </textarea>
                </div>
                <div class="weightStyle">
                    <input type="number" v-model="question.degree" @input="limitMaxNumber($event, idx)" autocomplete="off" class="form-control inputBackgroundColor"> <span class="text-center d-flex align-items-center"> / {{template.weight}}</span>
                </div>
            </div>
            <div>
                <div class="m-c-answer-container d-flex flex-column gap-2">
                    <div>Answer</div>
                    <textarea id="a-1" type="text" placeholder="Enter Answer" class="q-input w-100"
                              autocomplete="off"
                              disabled="true"
                              :value="question.answer"
                    >
                    </textarea>


                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'freeText-component',
        data() {
            return {
            }
        },

        async mounted() {
            this.getValue();
            console.log(this.template);
        },
        props: ['template' , 'isShown'],
        methods: {
            getValue(e){
                console.log(e);
            },
            limitMaxNumber(e, idx){
                if(this.template.weight < e.target.value){
                    console.log("W : ",  e.target.value, idx);
                    // e.target.value = this.template.weight;
                    this.template.questions[idx]['degree'] =  this.template.weight;
                }else{
                    this.template.questions[idx]['degree']  = Math.abs(e.target.value);
                }

                // e.target.value = Math.abs(e.target.value);

                console.log('Q > ', this.template.questions)
            }
        }
    }
</script>

<style scoped>
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    .inputBackgroundColor{
        background-color: transparent;
        border: none;
        color: var(--main-color);
        width:62px;
        height: 30px;
        text-align: center;
    }
    .weightStyle{
        border: 1px solid var(--border-color-profile-icon);
        background-color: var(--tabLinkBackgroundColorTemplate);
        border-radius: 10px;
        padding: 7px;
        height: fit-content;
        display: flex;
        flex-wrap: wrap;
    }
    .q-input {
        pointer-events: none;
        background-color: transparent !important;
        border: 1px solid #39525C;
        border-radius: 4px;
        color: var(--main-color);
        padding: 10px;
        overflow-y: auto;
        overflow-x: hidden;
        min-height: 60px;
        max-height: 60px;
    }

    .question-container {
        /*border-bottom: 1px solid #e65c00;*/
        margin-bottom: 20px;
        padding-bottom: 20px;
    }

    .question-container:last-child {
        border-bottom: none;
    }
</style>